import {
  TOKENS_INIT,
  TOKENS_UPDATE,
  PAGE_TOKENS_INIT,
  PAGE_TOKENS_UPDATE,
  PAGE_TOKENS_TOTAL_UPDATE,
  PAGE_TOKENS_LIMIT_UPDATE,
  GET_HOT_TOKEN,
  GET_HOT_TOKEN_SUCCESS,
} from '../actions/tokens'

const initTokens = []

export function tokensReducer(state = initTokens, action) {
  switch (action.type) {
    case TOKENS_UPDATE:
      return action.payload
    case TOKENS_INIT:
      return initTokens
    default:
      return state
  }
}

export function hotTokensReducer(state = { hotTokens: [] }, action) {
  switch (action.type) {
    case GET_HOT_TOKEN_SUCCESS:
      return { ...state, hotTokens: action.payload }
    case GET_HOT_TOKEN:
      return state
    default:
      return state
  }
}

var initPageTokens = {
  start_page: 1,
  start_item: 0,
  page_limit: 20,
  total_items: 10000,
  current_page: 1,
}

export function pageTokensReducer(state = initPageTokens, action) {
  switch (action.type) {
    case PAGE_TOKENS_UPDATE:
      initPageTokens.current_page = action.payload
      initPageTokens.start_item +=
        (initPageTokens.current_page - initPageTokens.start_page) * initPageTokens.page_limit
      initPageTokens.start_page = action.payload
      state = initPageTokens
      return state
    case PAGE_TOKENS_INIT:
      return initPageTokens
    case PAGE_TOKENS_TOTAL_UPDATE:
      initPageTokens.total_items = action.payload
      state = initPageTokens
      return state
    case PAGE_TOKENS_LIMIT_UPDATE:
      state.page_limit = action.payload
      state.start_item = (state.current_page - 1) * state.page_limit
      return state
    default:
      return state
  }
}
